const baseUrl = 'https://digitalhuman.chwhyun.com/api'
// const baseUrl = 'http://192.168.0.40:8085/'

export { baseUrl }
